
define('text!_popup.html',[],function () { return '\r\n<h2 class="bigheader"; style="padding-top:4px">{Prison_name}</h2>\r\n<div style="padding-bottom:5px;">\r\n  <em>{City}, {state}</em>\r\n</div>\r\n<h3 class="lilheader" style="display:inline; color: #CE473D">Industries:</h3>\r\n<div style="display:inline; align:left">{Industries}</div>';});

